// @ts-nocheck
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as Types from '../../api/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type SubpagesMenu_Subpage_Fragment = (
  { readonly __typename: 'Subpage' }
  & Pick<Types.Subpage, 'id' | 'slug' | 'title'>
  & { readonly roles?: Types.Maybe<ReadonlyArray<(
    { readonly __typename: 'Role' }
    & Pick<Types.Role, 'id' | 'name'>
  )>>, readonly groups?: Types.Maybe<ReadonlyArray<(
    { readonly __typename: 'UserGroup' }
    & Pick<Types.UserGroup, 'id' | 'name'>
  )>> }
);

export type SubpagesMenu_HoldCoSubpage_Fragment = (
  { readonly __typename: 'HoldCoSubpage' }
  & Pick<Types.HoldCoSubpage, 'id' | 'slug' | 'title'>
  & { readonly roles?: Types.Maybe<ReadonlyArray<(
    { readonly __typename: 'Role' }
    & Pick<Types.Role, 'id' | 'name'>
  )>>, readonly groups?: Types.Maybe<ReadonlyArray<(
    { readonly __typename: 'UserGroup' }
    & Pick<Types.UserGroup, 'id' | 'name'>
  )>> }
);

export type SubpagesMenuFragment = SubpagesMenu_Subpage_Fragment | SubpagesMenu_HoldCoSubpage_Fragment;

export type CreateSubpageMutationVariables = Types.Exact<{
  subjectId: Types.Scalars['ID'];
  subjectType: Types.Scalars['String'];
  title: Types.Scalars['String'];
}>;


export type CreateSubpageMutation = (
  { readonly __typename: 'Mutation' }
  & { readonly createSubpage?: Types.Maybe<(
    { readonly __typename: 'CreateSubpageMutation' }
    & { readonly subpage?: Types.Maybe<(
      { readonly __typename: 'Subpage' }
      & Pick<Types.Subpage, 'id' | 'title' | 'slug'>
      & { readonly roles?: Types.Maybe<ReadonlyArray<(
        { readonly __typename: 'Role' }
        & Pick<Types.Role, 'id' | 'name'>
      )>>, readonly groups?: Types.Maybe<ReadonlyArray<(
        { readonly __typename: 'UserGroup' }
        & Pick<Types.UserGroup, 'id' | 'name'>
      )>> }
    ) | (
      { readonly __typename: 'HoldCoSubpage' }
      & Pick<Types.HoldCoSubpage, 'id' | 'title' | 'slug'>
      & { readonly roles?: Types.Maybe<ReadonlyArray<(
        { readonly __typename: 'Role' }
        & Pick<Types.Role, 'id' | 'name'>
      )>>, readonly groups?: Types.Maybe<ReadonlyArray<(
        { readonly __typename: 'UserGroup' }
        & Pick<Types.UserGroup, 'id' | 'name'>
      )>> }
    )> }
  )> }
);

export const SubpagesMenuFragmentDoc = gql`
    fragment SubpagesMenu on SubpageInterface {
  id
  slug
  title
  roles {
    id
    name
  }
  groups {
    id
    name
  }
}
    `;
export const CreateSubpageDocument = gql`
    mutation CreateSubpage($subjectId: ID!, $subjectType: String!, $title: String!) {
  createSubpage(subjectId: $subjectId, subjectType: $subjectType, title: $title) {
    subpage {
      ... on Subpage {
        id
        title
        slug
        roles {
          id
          name
        }
        groups {
          id
          name
        }
      }
      ... on HoldCoSubpage {
        id
        title
        slug
        roles {
          id
          name
        }
        groups {
          id
          name
        }
      }
    }
  }
}
    `;
export type CreateSubpageMutationFn = Apollo.MutationFunction<CreateSubpageMutation, CreateSubpageMutationVariables>;

/**
 * __useCreateSubpageMutation__
 *
 * To run a mutation, you first call `useCreateSubpageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubpageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubpageMutation, { data, loading, error }] = useCreateSubpageMutation({
 *   variables: {
 *      subjectId: // value for 'subjectId'
 *      subjectType: // value for 'subjectType'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useCreateSubpageMutation(baseOptions?: Apollo.MutationHookOptions<CreateSubpageMutation, CreateSubpageMutationVariables>) {
        return Apollo.useMutation<CreateSubpageMutation, CreateSubpageMutationVariables>(CreateSubpageDocument, baseOptions);
      }
export type CreateSubpageMutationHookResult = ReturnType<typeof useCreateSubpageMutation>;
export type CreateSubpageMutationResult = Apollo.MutationResult<CreateSubpageMutation>;
export type CreateSubpageMutationOptions = Apollo.BaseMutationOptions<CreateSubpageMutation, CreateSubpageMutationVariables>;